import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/category/roof-leaks")({
  beforeLoad: () => { throw redirect({ to: "/blog/category/$category", params: { category: "roof-leaks" }, statusCode: 301 }); },
});
